import { render, staticRenderFns } from "./ItemPictures.vue?vue&type=template&id=1605674a&"
import script from "./ItemPictures.vue?vue&type=script&lang=js&"
export * from "./ItemPictures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports